import Mutations from '../../odata/mutations';

export default { ...new Mutations('incomeLine'), ...new Mutations('incomeLines') };
